<div
	[class]="
		cn(
			size() === 'large' &&
				'aspect-square w-full sm:aspect-classic lg:aspect-video lg:h-[85vh] lg:max-h-200 lg:min-h-146',
			size() === 'small' && 'h-68 md:h-80',
			'relative'
		)
	"
>
	<vp-slider
		[config]="sliderConfig"
		[itemTemplate]="slideTpl"
		[items]="items()"
		[navTemplate]="navTpl"
		class="absolute inset-0"
	/>
	<ng-template #slideTpl let-index="index" let-item>
		<vp-hero-item
			[alignment]="alignment()"
			[contentMargin]="contentMargin()"
			[heading]="item.heading"
			[image]="item.image"
			[indexNumber]="index"
			[link]="item.link"
			[overline]="item.overline"
			[size]="size()"
			[sticker]="item.sticker"
			[useEagerLoading]="useEagerLoading()"
			[verticalAlignment]="verticalAlignment()"
			[video]="item.video"
			[videoInitialQuality]="videoInitialQuality()"
		>
			<vp-hero-item-sub-heading>
				{{ item.subHeading }}
			</vp-hero-item-sub-heading>
		</vp-hero-item>
	</ng-template>
	<ng-template #navTpl let-nav>
		<vp-slider-nav-button
			[disabled]="!nav.canScrollPrev"
			(pressed)="nav.scrollPrev()"
			direction="prev"
			variant="light"
		/>
		<vp-slider-nav-button
			[disabled]="!nav.canScrollNext"
			(pressed)="nav.scrollNext()"
			direction="next"
			variant="light"
		/>
	</ng-template>
</div>
